interface PdfPreviewProps {
  src: string;
}

export function PdfPreview({ src }: PdfPreviewProps) {
  return (
    <iframe
      src={src}
      title="PDF preview"
      sandbox="allow-same-origin"
      className="h-full w-full border-none"
      data-testid="project-files-pdf-preview"
    />
  );
}
